import Upsertable from '@/models/Upsertable'
import { useAgriHarvestStore } from '@/stores/agriHarvestStore'
import { useModelName } from '@/composables/useModelName.js'
import { ModelRegistry } from '@/models/modelRegistry.js'

export default class AgriHarvest extends Upsertable {
  static store() {
    return useAgriHarvestStore()
  }

  store() {
    return AgriHarvest.store()
  }

  static all() {
    return AgriHarvest.store().all()
  }

  static find(uuid) {
    const obj = AgriHarvest.store().find(uuid)
    let agriHarvest = new AgriHarvest()
    return Object.assign(agriHarvest, obj)
  }

  static findAllByCustomerUuid(uuid) {
    return AgriHarvest.store().filter((e) => e.customer_uuid === uuid)
  }
}

useModelName(AgriHarvest, "AgriHarvest")
ModelRegistry.register(AgriHarvest, "AgriHarvest")